class Form {
    init() {
        document.addEventListener('DOMContentLoaded', (e) => {
            var fields = document.querySelectorAll('input, textarea')
            this.eventHandler(fields)
        })
    }

    eventHandler(fields) {
        this.autofilled(fields)
        this.focused(fields)
    }

    autofilled(fields) {
        const AUTOFILLED = 'data-autofilled'
        this.onAutoFillStart = (el) => el.setAttribute(AUTOFILLED, 'true')
        this.onAutoFillCancel = (el) =>  el.setAttribute(AUTOFILLED, 'false')

        fields.forEach((el) => {
            if (el.value) {
                this.onAnimationStart(el.parentNode, 'onAutoFillStart')
            }
            el.addEventListener('animationstart', (e) => {
                this.onAnimationStart(el.parentNode, e.animationName)
            })
        })
    }
    
    onAnimationStart(target, animationName) {
        switch (animationName) {
            case 'onAutoFillStart':
                return this.onAutoFillStart(target)
            case 'onAutoFillCancel':
                return this.onAutoFillCancel(target)
        }
    }

    focused(fields) {
        const FOCUSED = 'data-focused'
        this.onFocusStart = (el) => el.setAttribute(FOCUSED, 'true')
        this.onFocusCancel = (el) =>  el.setAttribute(FOCUSED, 'false')

        fields.forEach((el) => {
            el.addEventListener('focus', (e) => {
                this.onFocusStart(e.target.parentNode)
            })

            el.addEventListener('blur', (e) => {
                if (e.target.value) return
                this.onFocusCancel(e.target.parentNode)
                this.onAutoFillCancel(e.target.parentNode)
            })
        })
    }
}

export const form = new Form()